var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from "@tanstack/react-query";
import { CheckCircle2Icon, Eye, EyeOff } from "lucide-react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
// Import Lucide icons
import { supabase } from "src/clients/supabase";
import { Button } from "src/components/Button";
import { Input } from "src/components/Input";
import LoadingSpinner from "src/components/LoadingSpinner";
import { SimpleLayout, SimpleLayoutView } from "src/components/SimpleLayout";
import { useUser } from "src/stores/user";
export var PasswordResetView = function () {
    var user = useUser();
    var navigate = useNavigate();
    var _a = useState(""), newPassword = _a[0], setNewPassword = _a[1];
    var _b = useState(false), showPassword = _b[0], setShowPassword = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var resetPasswordMutation = useMutation({
        mutationFn: function (password) { return __awaiter(void 0, void 0, void 0, function () {
            var error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, supabase.auth.updateUser({ password: password })];
                    case 1:
                        error = (_a.sent()).error;
                        if (error)
                            throw error;
                        return [2 /*return*/];
                }
            });
        }); },
        onSuccess: function () {
            setNewPassword("");
            setError(null);
            navigate("/");
            toast.success("Password updated successfully", { icon: _jsx(CheckCircle2Icon, { className: "h-4 w-4" }) });
        },
        onError: function (error) {
            setError("Error updating password: ".concat(error.message));
        },
    });
    var handleSubmit = function (e) {
        e.preventDefault();
        resetPasswordMutation.mutate(newPassword);
    };
    return (_jsx(SimpleLayout, { children: _jsx(SimpleLayoutView, { className: "flex h-dvh flex-col items-center justify-center", children: _jsxs("div", { className: "flex w-full flex-col items-start gap-4 md:w-[24rem]", children: [_jsxs("div", { className: "flex flex-col gap-1", children: [_jsx("h1", { className: "font-medium text-secondary", children: "Reset Password" }), _jsxs("div", { className: "text-sm text-secondary", children: ["Resetting password for ", user === null || user === void 0 ? void 0 : user.email] })] }), _jsxs("form", { onSubmit: handleSubmit, className: "flex w-full flex-col gap-4", children: [_jsxs("div", { className: "relative", children: [_jsx(Input, { type: showPassword ? "text" : "password", value: newPassword, onChange: function (e) { return setNewPassword(e.target.value); }, placeholder: "New Password", required: true }), _jsx(Button, { type: "button", variant: "ghost", size: "icon-sm", onClick: function () { return setShowPassword(!showPassword); }, className: "absolute right-1 top-1/2 -translate-y-1/2 transform", children: showPassword ? _jsx(EyeOff, { size: 20 }) : _jsx(Eye, { size: 20 }) })] }), error && _jsx("div", { className: "text-xs text-red-600", children: error }), _jsx(Button, { type: "submit", disabled: resetPasswordMutation.isPending || !newPassword, children: resetPasswordMutation.isPending ? (_jsx(LoadingSpinner, { size: "xs", variant: "background" })) : ("Update Password") })] })] }) }) }));
};
